import { MenuApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const menuApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexMenuList),
};
